import React from 'react';

export const ProgressLoader = ({ progress, message }) => {
  return (
    <div className='progress-loader-overlay'>
      <div className='progress-loader-card'>
        <div className='progress-loader-icon'>
          <i className='fa-solid fa-file-excel'></i>
        </div>
        <p className='progress-loader-message'>{message || 'Generando informe...'}</p>
        <div className='progress-loader-bar-container'>
          <div
            className='progress-loader-bar'
            style={{ width: `${progress}%` }}
          ></div>
        </div>
        <p className='progress-loader-percent'>{progress}%</p>
      </div>
    </div>
  );
};
